import { FC, ComponentProps } from 'react';
import { IFeatureBase } from 'mod/featureV2/interface';
import cn from 'classnames';

export type IProps = ComponentProps<'div'> & {
    feature?: IFeatureBase;
};

export const FeatureSubtitle: FC<IProps> = ({ className, style, feature }) => {
    const { subtitle, theme, } = feature || {};
    const { subtitleClassName } = theme || {};
    return !subtitle ? null : (
        <div
            className={cn('g-feature-subtitle text-wrap', subtitleClassName, className)}
            style={style}
            dangerouslySetInnerHTML={{ __html: subtitle }}
        />
    )
};
